import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import { useTvShowEpisodesQuery } from "@/hooks";
import { LIST_PAGE_LIMIT } from "@/lib/constants";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TvShowEpisodesList(_ref) {
  var id = _ref.id,
      _ref$showHeader = _ref.showHeader,
      showHeader = _ref$showHeader === void 0 ? false : _ref$showHeader;

  var _useTvShowEpisodesQue = useTvShowEpisodesQuery({
    variables: {
      id: id,
      offset: 0,
      limit: LIST_PAGE_LIMIT
    },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first"
  }),
      data = _useTvShowEpisodesQue.data,
      result = _objectWithoutProperties(_useTvShowEpisodesQue, _excluded);

  var items = data === null || data === void 0 ? void 0 : data.children;
  var header = useMemo(function () {
    if (showHeader) {
      return {
        text: "エピソード一覧"
      };
    } else {
      return null;
    }
  }, [showHeader]);
  return /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, result), {}, {
    itemComponent: ListRow,
    header: header,
    items: items,
    limit: LIST_PAGE_LIMIT,
    viewTypeClassName: "list"
  }));
}